import { useParams, useSearchParams } from 'react-router-dom';
import { QRPrintPage } from '../components/qr/QRPrintPage';

export function QRTrainerPrint() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const name = searchParams.get('name') || 'Trener Spotto';
  const url = `https://spotto.pl/trainer/${id}/trainings`;

  return <QRPrintPage url={url} entityName={name} entityType="trainer" />;
}
